/** @jsx jsx */
import { jsx, useThemeUI } from "theme-ui"
import { rgba } from "polished"

const BGImage = ({ children }) => {
  const { theme } = useThemeUI()

  return (
    <div
      sx={{
        width: `100%`,
        height: [`400px`, `500px`],
        maxHeight: `1200px`,
        zIndex: 1,
        ".gatsby-image-wrapper": {
          position: `static !important`,
          filter: `grayscale(100%)`,
          opacity: `0.3`,
          "> div": {
            paddingBottom: `0 !important`,
            height: [`400px !important`, `500px !important`],
            maxHeight: `1200px`,
          },
        },
        "&:before": {
          content: `""`,
          height: `100%`,
          left: 0,
          top: 0,
          position: `absolute`,
          width: `100%`,
          mixBlendMode: `soft-light`,
          zIndex: 2,
          background: `linear-gradient(to top, rgba(0, 0, 0, 0) 0%, ${rgba(
            theme.colors.background,
            1
          )} 100%)`,
        },
        "&:after": {
          backfaceVisibility: `hidden`,
          content: `""`,
          height: `100%`,
          left: 0,
          top: 0,
          position: `absolute`,
          width: `100%`,
          background: `linear-gradient(${rgba(
            theme.colors.background,
            0.3
          )} 10%, ${rgba(theme.colors.background, 1)} 90%)`,
        },
      }}
    >
      {children}
    </div>
  )
}

export default BGImage
